module.exports = __webpack_public_path__ + "img/car-mirrors.0cbeebc6.svg";